import { useQuery } from '@tanstack/react-query';
import { getSelfServiceLandingPageData } from '../../api/selfServiceServices';
import { landingPageDataTanstackCacheKey } from '../../portal/containers/users/hooks/useAuthenticators';

export const useSelfServiceData = () => {
  return useQuery({
    queryKey: [landingPageDataTanstackCacheKey],
    queryFn: getSelfServiceLandingPageData,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
  });
};
